import { Icon, IconName } from '@aibees/shared/components/icon';
import { TextEllipsis } from '@aibees/shared/components/text-ellipsis';
import { classnames } from '@aibees/shared/utils';
import { Avatar, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DropDownValueSingleProps as Props } from './types';

export const DropDownValueSingle = memo(
  ({ className, selectedOptions }: Props) => {
    const firstSelectedOptipn = selectedOptions?.[0];

    if (!firstSelectedOptipn) return null;

    return (
      <Styled.Wrapper
        className={classnames('DropDownValueSingle', className)}
        sx={SX.root}
      >
        <Styled.StartBox>
          {firstSelectedOptipn?.startIcon && (
            <Icon
              name={firstSelectedOptipn?.startIcon as IconName}
              size={18}
              sxx={firstSelectedOptipn?.startIconSx}
            />
          )}
          {firstSelectedOptipn?.img && (
            <Avatar size={24} src={firstSelectedOptipn?.img} />
          )}
          <Styled.LabelsBox>
            <TextEllipsis
              lineHeight={1}
              fontWeight={600}
              // color="grey.600"
              variant="body3"
              w={'100%'}
            >
              {firstSelectedOptipn?.label}
            </TextEllipsis>
            {/* <Typography
              lineHeight={1}
              fontWeight={500}
              color="grey.600"
              variant="body4"
            >
              {firstSelectedOptipn?.label}
            </Typography> */}
            {firstSelectedOptipn?.subLabel && (
              <Typography lineHeight={1} color="grey.500" variant="body5">
                {firstSelectedOptipn?.subLabel}
              </Typography>
            )}
          </Styled.LabelsBox>
        </Styled.StartBox>
        {(firstSelectedOptipn?.metadata || firstSelectedOptipn?.endIcon) && (
          <Styled.EndBox>
            <Typography color="grey.500" variant="body4">
              {firstSelectedOptipn?.metadata}
            </Typography>
            {firstSelectedOptipn?.endIcon && (
              <Icon
                name={firstSelectedOptipn?.endIcon as IconName}
                size={20}
                sxx={firstSelectedOptipn?.endIconSx}
              />
            )}
          </Styled.EndBox>
        )}
      </Styled.Wrapper>
    );
  }
);

DropDownValueSingle.displayName = 'DropDownValueSingle';
